//ensure only 1 dropdown is open at a time
document.querySelectorAll('.collection-filter details').forEach((details) => {
  details.addEventListener('click', function () {
    const siblings = getAllSiblings(this, 'DETAILS')
    siblings.forEach((sibling) => {
      sibling.open = false
    })
  })
})

function getAllSiblings(element, selector) {
  const parent = element.parentElement
  const children = [...parent.children]
  return children.filter(
    (child) => child !== element && child.tagName === selector
  )
}
